import { useAuth } from '../../contexts/AuthContext';

export default function AdminGate({ children }) {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="px-5 py-6">
        <div className="space-y-2">{[...Array(4)].map((_, i) => <div key={i} className="h-16 rounded bg-[#F8F9FA] dark:bg-[#151a25] skeleton" />)}</div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return (
      <div className="px-5 py-6">
        <div className="max-w-[400px] mx-auto mt-12">
          <div className="rounded-lg border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-6 py-8 text-center">
            <svg className="w-10 h-10 text-[#9CA3AF] dark:text-[#505a6e] mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <h2 className="text-[18px] font-semibold text-[#111827] dark:text-[#e2e8f0] mb-2" style={{ fontFamily: 'var(--font-sans)' }}>Administrator Access Required</h2>
            <p className="text-[14px] text-[#6B7280] dark:text-[#8892a8]" style={{ fontFamily: 'var(--font-sans)' }}>This page is restricted to administrators.</p>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
